import { render } from "./CoverImage.vue?vue&type=template&id=46c6bdd4&ts=true"
import script from "./CoverImage.vue?vue&type=script&lang=ts"
export * from "./CoverImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__